import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Footer.css'
import jo from './../assest/images/navigation/jo.jpg'
export const Footer = () => {
  return (
    <div className='footer'>
<Container>
<div className='row'>
    <div className='col-lg-6 col-md-6 col-sm-6'>
        <img src={jo}/>
    </div>

    <div className='col-lg-6 col-md-6 col-sm-6'>
    <div className='icon'>
        <a href='https://www.facebook.com/jaafar.digitalmarketing?mibextid=ZbWKwL'><i className="fa-brands fa-facebook-f" style={{color: "#7d26cd " ,borderRadius: "50%",padding: "15px 15px",marginRight:"20px",fontSize:"20px"}}></i></a>
       <a href='https://instagram.com/jaafar.homam.ahmad?igshid=NGVhN2U2NjQ0Yg=='><i className="fa-brands fa-instagram" style={{color: "#7d26cd " ,borderRadius: "50%",padding: "15px 15px",marginRight:"20px",fontSize:"20px"}}></i></a>
       <a href='https://www.linkedin.com/in/jaafar-ahmad-92333824a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'><i className="fa-brands fa-linkedin-in" style={{color: "#7d26cd " ,borderRadius: "50%",padding: "15px 15px",fontSize:"20px"}}></i></a>
       </div>
    </div>
</div>
</Container>
    </div>
  )
}
